import { DTO } from "./dto.js";

export class CarreraDTO extends DTO {
    constructor() {
        super();
        this.resolucion = "";
        this.nombre = "";
        this.materias = [];
    }

    cargarDTO(dto) {
        super.cargarDTO(dto);

        if (dto.resolucion !== undefined) { this.resolucion = dto.resolucion; }
        if (dto.nombre !== undefined) { this.nombre = dto.nombre; }
        if (dto.materias !== undefined) { this.materias = dto.materias; }
    }

    clone(dto) {
        super.clone(dto);

        dto.resolucion = this.resolucion;
        dto.nombre = this.nombre;
        dto.materias = this.materias;
    }
}
